export default __webpack_public_path__ + "static/media/Business_Mobile.f4f8b8f4.svg";